import { render, staticRenderFns } from "./PowerGrammarFixMain.vue?vue&type=template&id=30e99dc8&scoped=true"
import script from "./PowerGrammarFixMain.vue?vue&type=script&lang=js"
export * from "./PowerGrammarFixMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e99dc8",
  null
  
)

export default component.exports